module.exports = __webpack_public_path__ + "img/hb-banner.290b6da9.png";